import React, {useEffect, useState} from 'react';
import {actionAdmin, registerAdmin} from "../../api/web";
import $ from "../../utils/datatables";
import {GET_USERS_ROLE_URL} from "../../api";
import {capitalize} from "../../utils/capitalize";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import {useSelector} from "react-redux";

const Access = () => {

    const token = localStorage.getItem('jwtToken');

    const [editForm, setEditForm] = useState(false);
    const [stateReady, setStateReady] = useState(false);
    const [editId, setEditId] = useState(null);

    const {user} = useSelector((state) => state.auth.user);

    useEffect(() => {
        var table = $('#access').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Access Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(`${GET_USERS_ROLE_URL("superadmin")}`, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    data: {
                        pageNumber: (data.length + data.start) / data.length,
                        pageSize: data.length
                    },
                    success : function(res) {
                        let result = [];

                        res.results.map((data) => {
                            result.push({
                                raw: data
                            });
                        });

                        callback({
                            recordsTotal: res.count,
                            recordsFiltered: res.count,
                            data: result
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.username;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `${data.first_name || "blank"} ${data.last_name}`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.email || "blank";
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.job_title === "admin" ? data.is_superuser ? "Super Admin" : capitalize(data.job_title)  : capitalize(data.job_title);
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_user"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_user"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        $('#access').on('click', '.delete_user', function() {
            let extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 3
            };

            if(extract_td.raw.username === user.username) {
                toast.error('Sorry, this logged account cannot be deleted.', {position: "top-right", autoClose: 3000});
                return false;
            }

            const toastId = toast.loading('Please wait... contacting to server.', {position: "top-right"});

            actionAdmin("delete", extract_td.raw.id, {}).then((result) => {
                toast.dismiss(toastId);
                const _options = {
                    position: "top-right"
                };

                if(result.error === false) {
                    $('#access').DataTable().ajax.reload(null, false);
                    toast.success("User successfully removed.", _options);
                } else {
                    toast.error("Something went wrong.", _options);
                }
            });

            return false;
        });

        $('#access').on('click', '.edit_user', function() {
            let extract_td = table.row($(this).closest('tr')).data();
            setEditForm(true);
            setEditId(extract_td.raw.id);

            $("#username").val(extract_td.raw.username);
            $("#first_name").val(extract_td.raw.first_name);
            $("#last_name").val(extract_td.raw.last_name);
            $("#email").val(extract_td.raw.email);
            $("#mobile_number").val(extract_td.raw.phone_number);
            $("#role").val(extract_td.raw.job_title);
            $("#password, #passwordWrapper").prop('required', false).prop('disabled', true).hide();

            $('#admin_form').parsley();
            $("#modalUser").modal("show");

            return false;
        });

    }, [])

    const handleShowModal = () => {
        setEditForm(false);
        $('#admin_form').parsley();
        $("#password, #passwordWrapper").prop('required', true).prop('disabled', false).show();
        $("#modalUser").modal("show");
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const reloadTable = () => {
        $('#admin').DataTable().ajax.reload(null, false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        let data = {
            username: $("#username").val(),
            first_name: $("#first_name").val(),
            last_name: $("#last_name").val(),
            password: $("#password").val(),
            email: $("#email").val(),
            phone_number: $("#mobile_number").val(),
            job_title: "admin",
            is_superuser: $("#role").val() !== "admin"
        }

        if(editForm === true) {
            const removeKey = (key, {[key]: _, ...rest}) => rest;
            console.log(editId);
            actionAdmin("patch", editId, removeKey('password', data)).then((response) => {
                setStateReady(false);
                if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
                onCloseModal("modalUser", "admin_form");
                $('#access').DataTable().ajax.reload();
                return toast.success("User account successfully created.", {position: "top-right"});
            });

            return false;
        }

        registerAdmin(data).then((response) => {
            setStateReady(false);
            if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
            onCloseModal("modalUser", "admin_form");
            $('#access').DataTable().ajax.reload();
            return toast.success("User account successfully created.", {position: "top-right"});
        })
    }

    const onCloseModal = (id, form) => {
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $(`#${form}`).parsley().reset();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Access Control</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Access Control</h4>
                    </div>
                    {/*<div className="d-none d-md-block">*/}
                    {/*    <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>*/}
                    {/*</div>*/}
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Access Control</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="access" className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Username</th>
                                        <th className="wd-20p">Full Name</th>
                                        <th className="wd-20p">Email</th>
                                        <th className="wd-20p">Role</th>
                                        <th className="wd-20p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalUser", "admin_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit User" : "Create User"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} user to have access to the console</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="admin_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="usernameWrapper" className="form-group parsley-input">
                                            <label>Username<span className="tx-danger">*</span></label>
                                            <input id="username" type="text" className="form-control"
                                                   placeholder="Enter username"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#usernameWrapper" required/>
                                        </div>
                                        <div id="fnameWrapper" className="form-group parsley-input">
                                            <label>First Name<span className="tx-danger">*</span></label>
                                            <input id="first_name" type="text" className="form-control"
                                                   placeholder="Enter first name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#fnameWrapper" required/>
                                        </div>

                                        <div id="lnameWrapper" className="form-group parsley-input">
                                            <label>Last Name<span className="tx-danger">*</span></label>
                                            <input id="last_name" type="text" className="form-control"
                                                   placeholder="Enter last name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#lnameWrapper" required/>
                                        </div>

                                        <div id="emailWrapper" className="form-group parsley-input">
                                            <label>Email Address<span className="tx-danger">*</span></label>
                                            <input id="email" type="text" className="form-control"
                                                   placeholder="Enter email address"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#emailWrapper" required/>
                                        </div>

                                        <div id="mobileWrapper" className="form-group parsley-input">
                                            <label>Mobile Number<span className="tx-danger">*</span></label>
                                            <input id="mobile_number" type="text" className="form-control"
                                                   placeholder="Enter Mobile Number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#mobileWrapper" required/>
                                        </div>

                                        <div id="passwordWrapper" className="form-group parsley-input">
                                            <label>Password<span className="tx-danger">*</span></label>
                                            <input id="password" type="password" className="form-control"
                                                   placeholder="Enter new password"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#passwordWrapper"/>
                                        </div>

                                        <div id="typeWrapper" className="form-group parsley-input">
                                            <label>Role <span className="tx-danger">*</span></label>
                                            <select className="custom-select" id="role" required>
                                                <option value="" disabled selected>Select</option>
                                                <option value="super_admin">Super Admin</option>
                                                <option value="admin">Admin</option>
                                            </select>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-success btn-block">Update Account</button> : <button className="btn btn-success btn-block">Create Account</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Access;
